// Resolve duplicate destinations to one navigation entry, preferring the entry
// the user chose. Longer paths and query-specific destinations win first.
export function resolveSidebarItem(items, location, preferredId) {
  const candidates = [];
  const walk = (nodes) => nodes.forEach(item => {
    if (item.children) return walk(item.children);
    if (item.disabled || item.action) return;
    for (const to of [item.to, ...(item.extraPaths || [])]) {
      if (!to) continue;
      const [path, search] = to.split('?');
      if (location.pathname !== path && !location.pathname.startsWith(path + '/')) continue;
      const query = new URLSearchParams(location.search);
      if (search && [...new URLSearchParams(search)].some(([k, v]) => query.get(k) !== v)) continue;
      candidates.push({ id: item.id, score: path.length + (search ? 10000 : 0) });
    }
  });
  walk(items);
  candidates.sort((a, b) => b.score - a.score || Number(b.id === preferredId) - Number(a.id === preferredId));
  return candidates[0]?.id;
}
